import { Button } from "@/components/ui/button"
import { Dialog, DialogTrigger } from "@/components/ui/dialog"
import {
	TableHeader,
	TableRow,
	TableHead,
	TableBody,
	TableCell,
	Table,
} from "@/components/ui/table"
import { Edit } from "lucide-react"
import { AddVehicleDialogContent } from "./AddVehicleDialog"
import { VehicleModel } from "@/state/draft/vehicle"
import React from "react"

export type VehicleSummaryRow = {
	name: string
	odometer: string
	businessMiles: string
	rate: string
	businessValue: string
}

type VehicleSummaryTableProps = {
	vehicles: VehicleSummaryRow[]
	total: string
	onEditSubmit: (vehicle: VehicleModel) => void
	vehicleModel: VehicleModel
	isVehicleUpdating: boolean
}

export const VehicleSummaryTable: React.FC<VehicleSummaryTableProps> = ({
	vehicles,
	total,
	onEditSubmit,
	vehicleModel,
	isVehicleUpdating,
}) => {
	const [open, setOpen] = React.useState(false)
	return (
		<Table>
			<TableHeader>
				<TableRow className="bg-slate-200 hover:bg-slate-200">
					<TableHead className="text-foreground  w-[350px] px-4">
						Vehicle
					</TableHead>
					<TableHead className="text-foreground px-4">
						Odometer <span className="font-normal">(Start of Year)</span>
					</TableHead>
					<TableHead className="text-foreground px-4">Business Miles</TableHead>
					<TableHead className="text-foreground px-4">Rate</TableHead>
					<TableHead className="text-foreground px-4">Business Value</TableHead>
					<TableHead className="text-foreground"></TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{vehicles.map((vehicle, index) => (
					<TableRow key={index}>
						<TableCell className="px-4">{vehicle.name}</TableCell>
						<TableCell className="px-4">{vehicle.odometer}</TableCell>
						<TableCell className="px-4">{vehicle.businessMiles}</TableCell>
						<TableCell className="px-4">{vehicle.rate}</TableCell>
						<TableCell className="px-4">{vehicle.businessValue}</TableCell>
						<TableCell className="px-4 text-right">
							<Dialog open={open} onOpenChange={setOpen}>
								<DialogTrigger asChild>
									<Button variant="outline" className="px-3">
										<Edit className="w-4 h-4" />
									</Button>
								</DialogTrigger>
								{(open || isVehicleUpdating) && (
									<AddVehicleDialogContent
										submiting={isVehicleUpdating}
										vehicle={vehicleModel}
										onSubmit={(newModel) => {
											onEditSubmit(newModel)
											setOpen(false)
										}}
									/>
								)}
							</Dialog>
						</TableCell>
					</TableRow>
				))}
				<TableRow className="bg-slate-100">
					<TableCell colSpan={5} className="font-medium px-4">
						Total
					</TableCell>
					<TableCell className="font-medium px-4 text-right">{total}</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	)
}
